export default __webpack_public_path__ + "static/media/03_Mini_Game.fb3b96ed.png";